import { render } from "./LoveItBoxComponent.vue?vue&type=template&id=12383ad4"
import script from "./LoveItBoxComponent.vue?vue&type=script&lang=js"
export * from "./LoveItBoxComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__